import React, { useEffect } from 'react'
import { GetStaticProps } from 'next'
import { QuizSteps, QuizProps, StepId } from '@types'
import Quiz from '@components/quiz'
import { useAppDispatch } from 'redux/hooks'
import { quiz as quizData } from 'data/quiz'
import { setStepValue } from 'redux/quiz'

const QuizPage: React.FC<QuizProps> = props => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setStepValue({ stepId: StepId.GENDER, value: 'female' }))
  }, [dispatch])

  return <Quiz {...props} />
}

export const getStaticProps: GetStaticProps = async context => {
  const quiz: QuizSteps[] = quizData
  const currentStep = 2
  const previousStep = 1
  const nextStep = currentStep < quiz.length - 1 ? currentStep + 1 : null
  const step = quiz[currentStep - 1]
  const isLastStep = currentStep == quiz.length - 1

  return {
    props: {
      step,
      currentStep,
      previousStep,
      nextStep,
      isLastStep,
      stepsCount: quiz.length,
    },
  }
}

export default QuizPage
